<template>
    <div>
 <!-- {{dataReqToFooter}} -->
        <b-field grouped group-multiline>

            <!-- <div class="control">
                <b-taglist attached>
                    <b-tag  type="is-text is-light">OPD No</b-tag>
                    <b-tag type="is-info is-light">{{dataReqToFooter[11].idopd}}</b-tag>
                </b-taglist>
            </div>


            <div class="control">
                <b-taglist attached>
                    <b-tag  type="is-text is-light">OPD Name</b-tag>
                    <b-tag type="is-info is-light">{{dataReqToFooter[12].opdname}}</b-tag>
                </b-taglist>
            </div> -->



            <div class="control">
                <b-taglist attached>
                    <b-tag  type="is-text is-light">ID LAB ORDER</b-tag>
                    <b-tag type="is-info is-light">{{dataReqToFooter[0].idlaborder}}</b-tag>
                </b-taglist>
            </div>

            <div class="control">
                <b-taglist attached>
                    <b-tag  type="is-text is-light">Visit ID</b-tag>
                    <b-tag type="is-info is-light">{{dataReqToFooter[1].ref_no}}</b-tag>
                </b-taglist>
            </div>

            <div class="control">
                <b-taglist attached>
                    <b-tag  type="is-text is-light">DateTime Walkin</b-tag>
                    <b-tag type="is-info is-light">{{dataReqToFooter[2].date_walkin  }}  ( {{dataReqToFooter[3].time_walkin  }} )</b-tag>
                </b-taglist>
            </div>

            <div class="control"  v-if="dataReqToFooter[4].date_walkout.length>0"  >
                <b-taglist attached>
                    <b-tag   type="is-text is-light">DateTime Walkout</b-tag>
                    <b-tag type="is-info is-light">{{dataReqToFooter[4].date_walkout  }}  ( {{dataReqToFooter[5].time_walkout  }} )</b-tag>
                </b-taglist>
            </div>
            <div class="control"  v-else   >
                <b-taglist attached>
                    <b-tag   type="is-text is-light">DateTime Walkout</b-tag>
                    <b-tag type="is-info is-light"> &nbsp;</b-tag>
                </b-taglist>
            </div>

            <div class="control">
                <b-taglist attached>
                    <b-tag  type="is-text is-light" >User Record</b-tag>
                    <b-tag type="is-info is-light">{{dataReqToFooter[6].user_rec_ }}</b-tag>
                </b-taglist>
            </div>

            <div class="control">
                <b-taglist attached>
                    <b-tag  type="is-text is-light">DVM</b-tag>
                    <b-tag type="is-info is-light">{{dataReqToFooter[7].dvm_ }}</b-tag>
                </b-taglist>
            </div>


            <div class="control">
                <b-taglist attached>
                    <b-tag  type="is-text is-light">Department</b-tag>
                    <b-tag type="is-info is-light" >{{dataReqToFooter[8].dept }}</b-tag>
                </b-taglist>
            </div>


            <div class="control">
                <b-taglist attached>
                    <b-tag  type="is-text is-light">DateTime Record</b-tag>
                    <b-tag  type="is-info is-light">   {{dataReqToFooter[9].date_req_rec }} ({{dataReqToFooter[10].time_req_rec }}) </b-tag>
                </b-taglist>
            </div>



        </b-field>
    </div>
</template>

<script>
    export default {
        name: "FooterRequest",
        props:{
            dataReqToFooter :Array
        }
    }
</script>

<style scoped>

</style>